import { Queue } from './queue/index.js';
/**
 * Extends Queue to add support for querying queued jobs by peer id
 */
export class PeerQueue extends Queue {
    has(peerId) {
        return this.find(peerId) != null;
    }
    find(peerId) {
        return this.queue.find(job => {
            return peerId.equals(job.options.peerId);
        });
    }
}
//# sourceMappingURL=peer-queue.js.map